import React from 'react';
import { Formik } from 'formik';
import { initialValue, validation } from 'constants/account-profile';
import LoginEmailForm from './LoginEmailForm';
import { mockLoginAlias } from 'pages/mockup/constant';

const LoginEmail = ({ username, width }) => {
  const handleSubmit = async () => {};

  return (
    <Formik
      initialValues={initialValue(mockLoginAlias)}
      validationSchema={validation}
      onSubmit={(values, { resetForm }) => handleSubmit(values, resetForm)}
      enableReinitialize
    >
      {(formikProp) => (
        <LoginEmailForm width={width} username={username} loginEmailLoading={false} formikProp={formikProp} />
      )}
    </Formik>
  );
};
export default LoginEmail;
